import select2 from 'select2';

(function($, window, document) {
    select2($);

    const allSelects = document.querySelectorAll('.select2');
    allSelects.forEach(function(select) {
        const jquerySelect = $(select);
        $(jquerySelect).select2({
            theme: "bootstrap-5",
            placeholder: $(jquerySelect).data('placeholder') ? $(jquerySelect).data('placeholder') : $(jquerySelect).attr('placeholder') ? $(jquerySelect).attr('placeholder') : null,
            maximumSelectionLength: $(jquerySelect).data('maximum-selection-length') ? $(jquerySelect).data('maximum-selection-length') : null,
            language: {
                errorLoading: function () {
                    return 'Die Ergebnisse konnten nicht geladen werden.';
                },
                inputTooLong: function (args) {
                    var overChars = args.input.length - args.maximum;

                    return 'Bitte ' + overChars + ' Zeichen weniger eingeben';
                },
                inputTooShort: function (args) {
                    var remainingChars = args.minimum - args.input.length;

                    return 'Bitte ' + remainingChars + ' Zeichen mehr eingeben';
                },
                loadingMore: function () {
                    return 'Lade mehr Ergebnisse…';
                },
                maximumSelected: function (args) {
                    var message = 'Du kannst nur ' + args.maximum + ' Element';

                    if (args.maximum != 1) {
                        message += 'e';
                    }

                    message += ' auswählen';

                    return message;
                },
                noResults: function () {
                    return 'Keine Übereinstimmungen gefunden';
                },
                searching: function () {
                    return 'Suche…';
                },
                removeAllItems: function () {
                    return 'Entferne alle Elemente';
                }
            }
        });

        $(jquerySelect).on('select2:select', function (e) {
            select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        $(jquerySelect).on('select2:unselect', function (e) {
            select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        $(jquerySelect).on('select2:clear', function (e) {
            select.dispatchEvent(new Event('change', { bubbles: true }));
        });
    });

    // // ToDO: Reset select2 on form reset
    // document.querySelectorAll('form').forEach(function(form) {
    //     if (form.querySelector('.select2')) {
    //         form.addEventListener('reset', function() {
    //             console.log('reset')
    //         });
    //     }
    // });
})(jQuery, window, document);
